import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

export type ConfirmPublishModalProps = {
  isOpen: boolean;
  confirm: () => void;
  cancel: () => void;
  draftItems: string[];
};

export const ConfirmPublishModal: React.FC<ConfirmPublishModalProps> = ({
  isOpen,
  confirm,
  cancel,
  draftItems,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={cancel}
    title="Publish offer"
    modalClassName="w-full md:w-[540px]"
    centerContent={true}
  >
    <div className="flex flex-col gap-6 text-left">
      <Typography variant="body" size="large" fontWeight="normal">
        All Programs and Extras that are part of this offer will become visible
        in your app and purchasable for your users.
      </Typography>
      <Typography variant="body" size="large" fontWeight="normal">
        Draft items which states will automatically turn into "Publish" are:
      </Typography>
      <div className="flex flex-col items-start">
        {draftItems.map((item) => (
          <Typography
            variant="body"
            size="large"
            fontWeight="normal"
            key={item}
          >
            - {item}
          </Typography>
        ))}
      </div>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={cancel}
          className="w-[180px]"
        >
          Go back
        </Button>
        <Button color="neutral" onClick={confirm} className="w-[180px]">
          Publish
        </Button>
      </div>
    </div>
  </Modal>
);
